import React from 'react';
import { modules } from '../data/masterclass';
export function FoundationCheck() {
  return <section aria-labelledby="modules-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-50" data-mp="15pkaiar1zsy3">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-51" data-mp="ro7vq2nmpxds">
        <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-52" data-mp="wo40w582buux">
          Class 1
        </p>
        <h2 id="modules-heading" className="mt-4 font-display text-5xl font-bold uppercase text-white sm:text-6xl" data-id="element-53" data-mp="hyy2ukkyoaom">
          The Foundation Check
        </h2>

        <ol className="mt-14 divide-y divide-ink-line border-y border-ink-line" data-id="element-54" data-mp="8z1lz54tcg44">
          {modules.map((item, i) => <li key={item.title} className="grid gap-3 py-8 sm:grid-cols-[4rem_1fr_1.2fr] sm:items-baseline sm:gap-8" data-id="element-55" data-mp="dyxqd5hfa9k7" data-mpi={i}>
              <span className="font-display text-3xl font-bold text-gold/50 tabular-nums" data-id="element-56" data-mp="3zoz4kdxz91j">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="font-display text-2xl font-semibold uppercase leading-tight text-white" data-id="element-57" data-mp="mg57e3f768zp">
                {item.title}
              </h3>
              <p className="leading-relaxed text-white/60" data-id="element-58" data-mp="vi4murakd50j">{item.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}